<template>
  <swiper
    class="main-banner main-banner__slider"
    v-if="hasSlides"
    :items="BANNERS"
    v-slot="{ item, index, isActive }"
    dots
    autoplay
  >
    <banner
      :back-as-img="false"
      :index="index"
      :data="item"
      in-slider
      :is-active="isActive"
      slot-name="MAIN_SLIDER"
    />
  </swiper>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Banner from '@/components/banner/banner.vue'
import Swiper from '@kit/swiper/swiper.vue';

export default {
  components: { Swiper, Banner },

  computed: {
    ...mapState('banners',{
      BANNERS: state => state.slider_main,
    }),

    hasSlides() {
      return this.BANNERS && this.BANNERS.length;
    },
  },

  methods: {
    ...mapActions('banners', ['getBanners']),
  },

  serverPrefetch() {
    return this.getBanners({ slots: ['slider_main'], withCategory: false} );
  },
}
</script>

<style lang="scss">
  .main-banner {
    margin: 0 auto;
    max-width: 1920px;
    overflow: hidden;
    .swiper-wrapper {
      margin: 0;
    }
    .swiper-slides {
      padding-left: 0;
      padding-right: 0;
      scroll-padding: 0;
      > * {
        padding: 0;
      }
    }
  }
</style>
